import { Link } from "react-router-dom";

export default function AboutStrip() {
  return (
    <section className="max-w-[1200px] mx-auto px-4 md:px-6 pb-4">
      <div className="rounded-lg overflow-hidden bg-primary-900">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-800 text-background-200 text-xs mb-4">
              <i className="ri-movie-2-line" />
              关于漂亮的保姆
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              你的追剧信息管家
            </h2>
            <p className="text-sm md:text-base text-background-300 leading-relaxed mb-6">
              漂亮的保姆专注影视剧资讯、剧情介绍与解析。从热播剧集到冷门口碑佳作，从剧情脉络梳理到演员阵容解析，我们用系统化的内容帮你在海量剧集中快速找到想看的故事。
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line" />
                了解更多
              </Link>
              <Link
                to="/news"
                className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-800 text-background-100 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-newspaper-line" />
                浏览资讯
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-3 border-t lg:border-t-0 lg:border-l border-primary-800">
            {[
              { num: "12+", label: "精选剧集" },
              { num: "8", label: "演员资料" },
              { num: "6", label: "剧集分类" },
            ].map((s) => (
              <div
                key={s.label}
                className="flex flex-col items-center justify-center py-8 border-r border-primary-800 last:border-r-0 lg:border-r-0 lg:border-b last:lg:border-b-0 border-primary-800"
              >
                <span className="font-heading text-3xl md:text-4xl font-bold text-accent-400">
                  {s.num}
                </span>
                <span className="mt-2 text-xs md:text-sm text-background-300">
                  {s.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}